/* eslint-disable */
import { produce } from "immer";
import {
  LINKS_FETCH_FAILURE,
  LINKS_FETCH_SUCCESS,
  LINKS_FETCH_START,
} from "../actions/types";

const usefulLinks = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case LINKS_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case LINKS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case LINKS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default usefulLinks;
